import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SessionStorageService {
    setItem(key: string, value: any): void {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error('Error saving to session storage', error);
        }
    }

    getItem<T>(key: string): T | null {
        try {
            const raw = sessionStorage.getItem(key);
            if (raw === null) return null;
            try {
                return JSON.parse(raw);
            } catch {
                return raw as unknown as T;
            }
        } catch (error) {
            console.error('Error reading from session storage', error);
            return null;
        }
    }

    removeItem(key: string): void {
        sessionStorage.removeItem(key);
    }

    clear(): void {
        sessionStorage.clear();
    }

    hasItem(key: string): boolean {
        return sessionStorage.getItem(key) !== null;
    }
}
